//--- ONLY METRIC NAME, IN FUTURE WE REPLACE ALL TEXT FROM CONST VALUE
export const CTR = "CTR";
